export default "__VITE_ASSET__CeQuSjIi__"